@let currentConfigValue = currentConfig();

@if (currentConfigValue.badge) {
  <rt-badge
    [color]="currentConfigValue.badge.color"
    [text]="currentConfigValue.badge.text"
    margin-left-small-xx
  />
}
